module.exports = __webpack_public_path__ + "static/media/icon-info.c51c4be2.svg";